module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/imgadvisor_spotlight_tablet_03@2x-d15a68cf9831cea16a072e045bd2f59c.jpg";